export const CSRF_HEADER = 'x-xsrf-token';
export const XSRF = 'frsx_csrf';

export const PERSONALIZED_CAMPAIGNS_FIELDS =
    '(open_campaigns(name,campaign_id,showstopper_ids,tab_ids,ends_at,plus_benefit(type,expires_at,state),plus_ends_at,starts_at,delivery_promise,discount,images(upcoming,mobile,campaigns),media(mobile,campaigns1x1,campaigns2x1,campaigns1x2,campaigns2x2),options,has_logo,plus_early_access),showstoppers,tabs,global_retail_events,upcoming_campaigns(name,campaign_id,discount,starts_at,images(upcoming),media(upcoming),has_logo,plus_benefit(type,expires_at,state),plus_early_access,brands))';

export enum CategoryTabIds {
    ALL = '1',
    MEN = '3',
    WOMEN = '2',
    KIDS = '4',
    HOME = '58',
    NEW_DEALS_TODAY = 'new-deals',
}
